/**
 * Stable key for a conflict acknowledgement — combines entity_id and
 * association_type_name so the same entity can appear in two distinct
 * association fields and be resolved independently.
 */
export const conflictKey = (
  entityId: string,
  associationTypeName: string
): string => `${entityId}|${associationTypeName}`;
